var DATA_GROUP_NAME_ATTR = 'data-group-name';
export function getInsuranceGroupNameAttr(groupName) {
    var _a;
    if (!groupName) {
        return {};
    }
    return _a = {}, _a[DATA_GROUP_NAME_ATTR] = groupName, _a;
}
